export const adoptLightStyles = (element: HTMLElement) => {
  const global = window
  const supportsAdoptingStyleSheets =
    global.ShadowRoot &&
    (global.ShadyCSS === undefined || global.ShadyCSS.nativeShadow) &&
    'adoptedStyleSheets' in Document.prototype &&
    'replace' in CSSStyleSheet.prototype

  const styles = (element.constructor as any).styles

  const myStyleSheet = new CSSStyleSheet()
  myStyleSheet.replace(styles)

  if (supportsAdoptingStyleSheets) {
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, myStyleSheet]
  } else {
    styles.forEach((s: any) => {
      const style = document.createElement('style')
      const nonce = (global as any)['litNonce']
      if (nonce !== undefined) {
        style.setAttribute('nonce', nonce)
      }
      style.textContent = s.cssText
      document.head.appendChild(style)
    })
  }
}
